<template>
    <div>
        <div class="uk-card uk-card-default uk-card-small uk-card-hover" style="height: 100%;">
            <div class="uk-card-body">

                <!-- Image -->
                <div>
                    <a class="tm-image-link"
                       :href="ShopItem.href">
                        <img v-if="ShopItem.image"
                             :src="ShopItem.image.src"
                             :alt="ShopItem.image.title">
                        <span v-else
                              class="uk-text-muted"
                              uk-icon="icon: image; ratio: 4;"></span>
                        <canvas width="300" height="300"></canvas>
                    </a>
                </div>

                <!-- Info -->
                <div class="tm-item-card-info">

                    <div class="tm-item-card-info-header">

                        <!-- Title -->
                        <a class="tm-item-card-title"
                           :href="ShopItem.href">{{ ShopItem.name }}</a>

                        <!-- Description -->
                        <div v-if="ShopItem.description"
                             v-html="ShopItem.description"
                             class="tm-item-card-description"></div>

                    </div>

                    <!-- Prices -->

                </div>

            </div>
            <div class="uk-card-footer">
                <shop-item-prices :shop-item="ShopItem"
                                  :shop-item-prices="ShopItemPrices"
                                  :shop-order-item="ShopOrderItem"
                                  :shop-item-warehouses="ShopItemWarehouses"
                                  v-on="$listeners">
                </shop-item-prices>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ShopItem: {
                type: Object,
                required: true
            },
            image: {
                type: Object,
                default() {
                    return {}
                }
            },
            ShopProduct: {
                type: Object,
                default() {
                    return {}
                }
            },
            ShopItemPrices: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            RelatedShopItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemProperties: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemTags: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopOrderItem: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data(){
            return {}
        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// ShopItemBlock.vue?200f85aa